module.exports = __webpack_public_path__ + "img/phone.5b56489d.png";